import React from 'react';
import ReactDOM from 'react-dom';
import Simulator from './Simulator';

ReactDOM.render(<Simulator />, document.getElementById('react-root'));



// WEBPACK FOOTER //
// src/main.js